export default IconUmbrella => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-umbrella" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M4 12a8 8 0 0 1 16 0z" />
  <path d="M12 12v6a2 2 0 0 0 4 0" />
</svg>`;